import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { IUserNotificationSchema } from '~/@api/generated-api-types-user/Api'

import { XIcon } from 'lucide-react'
import { Button } from '~/shadcn/ui/button/button'
import { cn } from '~/shadcn/lib/utils'
import { PageContainer } from '../page-container/PageContainer'
import {
  NotificationBannerIcon,
  type NotificationType,
} from './NotificationBannerIcon'
import { getColorByCategory } from './getNotificationColor'

type Props = {
  disabled?: boolean
  category: IUserNotificationSchema['category']
  type?: NotificationType
  message: ReactNode
  closeText?: string
  onClick?: () => void
}

function NotificationBanner({
  disabled,
  message,
  closeText,
  category,
  type,
  onClick,
}: Props) {
  return (
    <div
      className={cn(
        'flex w-full min-h-12 px-5 py-3',
        closeText != null ? 'flex-col sm:flex-row' : 'flex-row',
        'justify-between items-center'
      )}
      style={{ backgroundColor: getColorByCategory(category) }}>
      <PageContainer className="flex flex-row justify-between items-center w-full px-0 md:px-3 font-semibold">
        <div className="flex flex-row items-center">
          <div className="hidden md:flex mr-2 sm:mr-3 leading-5">
            <NotificationBannerIcon category={category} type={type} />
          </div>
          {message}
        </div>
        {closeText != null ? (
          <a
            onClick={onClick}
            className={cn(
              'self-center',
              'w-full sm:w-auto',
              'pt-2.5 sm:pt-0',
              'text-accent text-base text-nowrap cursor-pointer underline',
              'block md:inline text-right min-w-[150px]'
            )}>
            {closeText}
          </a>
        ) : type === 'admin_company_confirmation' ? (
          <Link
            to="/get-started-investor-signature"
            rel="noopener noreferrer"
            className={cn(
              'self-center',
              'text-accent text-base font-bold cursor-pointer underline',
              'min-w-[150px] text-right'
            )}>
            Podpísať rámcovú zmluvu
          </Link>
        ) : (
          <Button
            variant="ghost"
            size="icon"
            disabled={disabled}
            className="self-center"
            onClick={onClick}>
            <XIcon className="w-6 h-6" />
          </Button>
        )}
      </PageContainer>
    </div>
  )
}

export { NotificationBanner }
